import { Injectable } from '@angular/core';

export interface IDataLayerUser {
  department?: string;
  jobTitle?: string;
}

export interface IDataLayerLocation {
  page?: string;
  tab?: string;
  subTab?: string;
}

export interface IDataLayer {
  application: string;
  team: string;
  user?: IDataLayerUser;
  location?: IDataLayerLocation;
  role?: string;
}

export interface ITabChange {
  tab?: string;
  subTab?: string;
}

interface IWindowWithDataLayer extends Window {
  dataLayer: IDataLayer;
}

declare const window: IWindowWithDataLayer;
@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  public get dataLayer(): IDataLayer {
    return window.dataLayer;
  }

  public set user(user: IDataLayerUser) {
    window.dataLayer.user = user;

    this.dispatchEvent('emmet:adobe:user-updated');
  }

  public set location(location: IDataLayerLocation) {
    window.dataLayer.location = location;

    this.dispatchEvent('emmet:adobe:location-updated');
  }

  public set role(role: string) {
    window.dataLayer.role = role;

    this.dispatchEvent('emmet:adobe:role-updated');
  }

  private dispatchEvent(eventName: string) {
    const event = new Event(eventName);

    window.dispatchEvent(event);
  }
}
